/*
* @Author: zhangzhitao
* @Date: 2019-04-29 14:21:42
 * @Last Modified by: zhenghong7
 * @Last Modified time: 2019-09-26 14:36:41
*/

<template>
  <div class="page">
    <widget-store
      :scrollTop="0"
      :disabled="tipSwitch"
      @openSysConfig="
      handleOpenSysConfig"
      @clean="handleCleanCanvas"
      @save="handleSave"
    ></widget-store>
    <el-scrollbar
      wrap-class="m-main-scroll-wrap"
      @on-scrolling="handleScrollChange"
    >
      <div
        class="m-main-container"
        :style="containerStyle"
        v-if="!tipSwitch"
      >
        <data-view-canvas
          :viewInfo="viewInfo"
          :arrParts="arrParts"
          :activePartsIndex="activePartsIndex"
          :bgStyle="bgStyle"
          :maxWidth="maxWidth"
          :maxHeight="maxHeight"
          @choose="handleChooseWidget"
          @remove="handleRemoveWidget"
        ></data-view-canvas>
        <div
          class="u-virtual-module"
          v-if="virtualWidgetFlag"
          :style="`left:${virtualWidgetPos.x}px;top:${virtualWidgetPos.y}px`"
        >{{activeWidget.name}}</div>
      </div>
      <div
        class="m-main-wrap"
        v-if="tipSwitch"
      >
        <tips-wrap
          v-if="tipSwitch"
          @openSysConfig="
          handleOpenSysConfig"
        ></tips-wrap>
      </div>
    </el-scrollbar>

    <el-dialog
      :title="$t('management.dataView.data_view_all_config')"
      :visible.sync="sysConfigDialog"
      size="small"
      :area="[560,700]"
    >
      <el-form
        label-position="top"
        class="m-config-form"
        ref="configForm"
        :model="viewForm"
        :rules="viewFormRules"
      >
        <el-form-item
          :label="$t('management.dataView.data_view_name1')"
          prop="name"
        >
          <el-input
            v-model="viewForm.name"
            :placeholder="$t('management.dataView.data_view_name_placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.dataView.data_view_title1')"
          prop="title"
          :rules="[{
          required: viewForm.isTitleShow,
          message: $t('common.require_valid_error'),
          trigger: 'change'
        },max16ChartRule]"
        >
          <el-input
            v-model="viewForm.title"
            :disabled="!viewForm.isTitleShow"
            :placeholder="$t('management.dataView.data_view_title_placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.dataView.data_view_px')"
          prop="ratio"
        >
          <el-input
            v-model="viewForm.width"
            style="width: 234px;margin-right:12px;"
            :placeholder="$t('management.dataView.data_view_px_placeholder')"
          >
            <template slot="prepend">{{$t('management.dataView.width')}}</template>
          </el-input>
          <el-input
            v-model="viewForm.height"
            style="width: 234px;"
            :placeholder="$t('management.dataView.data_view_px_placeholder')"
          >
            <template slot="prepend">{{$t('management.dataView.height')}}</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.dataView.data_view_title_show')"
          prop="isTitleShow"
        >
          <el-switch v-model="viewForm.isTitleShow"></el-switch>
        </el-form-item>
        <el-form-item
          :label="$t('management.dataView.data_view_logo1')"
          prop="logoUrl"
        >
          <view-icon-upload
            type="menuIcon"
            v-model="viewLogoInfo"
          ></view-icon-upload>
        </el-form-item>
        <el-form-item
          :label="$t('management.dataView.data_view_bg1')"
          prop="backgroundImageUrl"
        >
          <div class="m-upload-container">
            <bg-upload
              type="displayBoardBackground"
              v-model="backgroundImgInfo"
            ></bg-upload>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('management.dataView.data_view_show_index')"
          prop="isShow"
        >
          <el-switch v-model="viewForm.isShow"></el-switch>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSaveViewForm"
        >{{$t('common.confirmBtn_text')}}</el-button>
        <el-button @click="handleCancelSave">{{$t('common.cancelBtn_text')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dataViewCanvas from './data-view-canvas'
import widgetStore from './widget-store'
import bgUpload from 'components/bg-upload/bg-upload'
import viewIconUpload from './view-icon-upload'
import tipsWrap from './tips-wrap'
import { requireRule, charRule, max16ChartRule, requireImgRule } from 'utils/validator'
import { getQueryString } from 'utils/mixin'

import axios from 'axios'
import API from 'api/api'

export default {
  name: 'data-view-configuration',
  data () {
    return {
      max16ChartRule: max16ChartRule,
      // 虚拟tag开关
      virtualWidgetFlag: false,
      // 虚拟tag位置
      virtualWidgetPos: {
        x: 0, y: 0
      },
      // 当前被拖拽的部件tag
      activeWidget: {},
      // 画板内的部件
      arrParts: [],
      // 当前选中部件index
      activePartsIndex: -1,
      // 看板全局配置dialog
      sysConfigDialog: false,
      // 看板全局配置
      viewForm: {
        name: '',
        title: '',
        isTitleShow: false,
        backgroundImageId: -1,
        logoId: -1,
        isShow: false,
        backgroundImageUrl: '',
        logoUrl: '',
        width: 1920,
        height: 1080
      },
      // 看板配置传值canvas的值
      viewInfo: {
        name: '',
        title: '',
        isTitleShow: false,
        backgroundImageId: -1,
        logoId: -1,
        isShow: false,
        backgroundImageUrl: '',
        logoUrl: ''
      },
      // 看板全局配置rules
      viewFormRules: {
        name: [requireRule, max16ChartRule, charRule],
        title: [requireRule, max16ChartRule, charRule],
        backgroundImageUrl: [requireImgRule],
        logoUrl: [requireImgRule],
        ratio: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.viewForm.width) {
              callback(new Error(this.$t('common.width_valid_null')))
            } else if (!this.viewForm.height) {
              callback(new Error(this.$t('common.height_valid_null')))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (!/^[1-9]+[0-9]*$/.test(this.viewForm.width)) {
              callback(new Error(this.$t('common.width_must_int')))
            } else if (!/^[1-9]+[0-9]*$/.test(this.viewForm.height)) {
              callback(new Error(this.$t('common.height_must_int')))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (this.viewForm.width > 50000 || this.viewForm.height > 50000) {
              callback(new Error(this.$t('management.dataView.max_px')))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      // 看板LOGO
      viewLogoInfo: {
        fileId: -1,
        path: ''
      },
      // 看板背景
      backgroundImgInfo: {
        fileId: -1,
        path: ''
      },
      // 看板提示开关
      tipSwitch: true,
      // 容器滚动条高度
      scrollTop: 0,
      // 容器滚动条宽度
      scrollLeft: 0,
      // 看板最大宽度
      maxWidth: 0,
      // 看板最大高度
      maxHeight: 0
    }
  },

  components: { dataViewCanvas, widgetStore, bgUpload, viewIconUpload, tipsWrap },

  computed: {
    bgStyle () {
      return {
        'background-image': `url(${this.viewInfo.backgroundImageUrl})`,
        'background-repeat': 'no-repeat',
        'background-size': 'contain',
        'background-position': 'center'
      }
    },
    containerStyle () {
      return {
        'width': `${this.maxWidth}px`,
        'height': `${this.maxHeight}px`
      }
    }
  },

  mounted () {
    this.$root.$on('dragIn', this.handleDragIn)
    this.$root.$on('closeTips', this.handleCloseTips)
    this._getDataViewKey()
  },

  methods: {
    // 关闭dialog并将viewForm值赋给viewInfo映射到页面
    handleSaveViewForm () {
      this.$refs.configForm.validate(valid => {
        if (valid) {
          this.viewInfo = JSON.parse(JSON.stringify(this.viewForm))
          this.maxWidth = parseInt(this.viewForm.width)
          this.maxHeight = parseInt(this.viewForm.height)
          this.sysConfigDialog = false
          this.tipSwitch = false
        }
      })
    },
    // 关闭dialog，取消viewForm更改的值
    handleCancelSave () {
      // let _width = this.viewForm.width
      // let _height = this.viewForm.height
      this.viewForm = JSON.parse(JSON.stringify(this.viewInfo))
      // this.viewForm.width = _width
      // this.viewForm.height = _height
      this.backgroundImgInfo = {
        path: this.viewInfo.backgroundImageUrl,
        fileId: this.viewInfo.backgroundImageId
      }
      this.viewLogoInfo = {
        path: this.viewInfo.logoUrl,
        fileId: this.viewInfo.logoId
      }
      this.$refs.configForm.resetValidates()
      this.sysConfigDialog = false
    },
    // 拖拽tag
    handleDragIn (widget, e) {
      if (!this.lockSwitch) this.isLock = false
      // 获取部件tag的宽度，拖拽的时候，拖着中心走
      let tagW = e.target.offsetWidth
      // 把当前拖拽的部件信息进行保留，让虚拟部件显示出来，跟着鼠标走
      this.activeWidget = widget
      this.virtualWidgetFlag = true
      let l = e.clientX - tagW / 2 + this.scrollLeft
      let t = e.clientY - 15 + this.scrollTop
      this.virtualWidgetPos = {
        x: l,
        y: t
      }
      document.onmousemove = e => {
        let l = e.clientX - tagW / 2 + this.scrollLeft
        let t = e.clientY - 15 + this.scrollTop
        this.virtualWidgetPos = {
          x: l,
          y: t
        }
      }
      document.onmouseup = e => {
        this.pushWidgetToBorder(widget, e)
        this.virtualWidgetFlag = false
        document.onmousemove = null // 释放全局捕获
        document.onmouseup = null
        document.onmousedown = null
      }
    },
    // 加载部件到看板画板内
    async pushWidgetToBorder (widget, e, pos) {
      let part = JSON.parse(JSON.stringify(widget))
      if (e) {
        part['xPos'] = e.clientX + this.scrollLeft
        part['yPos'] = e.clientY + this.scrollTop
      } else {
        part['xPos'] = pos.xPos
        part['yPos'] = pos.yPos
      }
      // 如果有可配置的属性，请求可配置的内容
      if (part.jsonUrl) {
        try {
          let json = await axios.get(part.jsonUrl)
          this.resolveSettingJson(json.data, part)
        } catch (e) {
          this.$set(part, 'option', {})
        }
      } else if (!part.option) {
        this.$set(part, 'option', {})
      }
      let Fn = Function
      let res = await axios.get(part.url)
      let mode = new Fn(`return ${res.data}`)()
      part['mode'] = mode.__esModule ? mode.default : mode
      // await http.get(`${part.url}`).then(res => {
      //   part['mode'] = new Fn(`return ${res}`)()
      // })
      this.arrParts.push(part)
      this.activePartsIndex = this.arrParts.length - 1
    },
    // 打开看板全局配置
    handleOpenSysConfig () {
      this.sysConfigDialog = true
    },
    // 关闭贴心小提示
    handleCloseTips () {
      // 当采用默认设置的时候，将看板的分辨率设置为1920* 1080
      this.maxWidth = 1920
      this.maxHeight = 1080
      this.tipSwitch = false
    },
    // 通过URL地址，判断是自定义首页入口进来的还是门户管理进来的
    _getDataViewKey () {
      let key = this.getQueryString('key')
      if (key) {
        this.tipSwitch = false
        this._getDataViewDetail(key)
        this.dataViewId = key
      }
    },
    // 获取看板详情
    _getDataViewDetail (key) {
      API.dataView.getDataViewDetail({ boardId: key }).then(res => {
        this.backgroundImgInfo.path = res.data.backgroundImageUrl
        this.viewLogoInfo.path = res.data.logoUrl
        this.viewForm.backgroundImageUrl = res.data.backgroundImageUrl
        this.viewForm.logoUrl = res.data.logoUrl
        this.viewForm.title = res.data.title
        this.viewForm.id = res.data.id
        this.viewForm.isShow = res.data.isShow === 0
        this.viewForm.name = res.data.name
        this.viewForm.isTitleShow = res.data.isDisplayBoardName === 0
        this.viewForm.height = res.data.height
        this.viewForm.width = res.data.width
        this.viewInfo = JSON.parse(JSON.stringify(this.viewForm))
        res.data.widgetList.forEach(widget => {
          let pos = {
            xPos: widget.xPos,
            yPos: widget.yPos
          }
          widget.type = widget.type === 1 ? 'line' : widget.type === 2 ? 'line2' : 0
          widget.resizable = widget.widgetHeight && widget.widgetWidth
          if (widget.widgetHeight) {
            widget.height = widget.widgetHeight
          }
          if (widget.widgetWidth) {
            widget.width = widget.widgetWidth
          }
          widget.option = widget.option ? JSON.parse(widget.option) : {}
          this.pushWidgetToBorder(widget, false, pos)
        })
        this.maxWidth = res.data.width
        this.maxHeight = res.data.height
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 清空画布
    handleCleanCanvas () {
      this.arrParts = []
      this.activePartsIndex = -1
    },
    // 选中某一部件
    handleChooseWidget (i) {
      this.activePartsIndex = i
    },
    // 移除部件
    handleRemoveWidget (i) {
      this.arrParts.splice(i, 1)
      if (this.activePartsIndex === i) {
        this.activePartsIndex = this.arrParts.length > 0 && i > 0 ? i - 1 : this.arrParts.length === 0 ? -1 : 0
      }
    },
    // 保存
    async handleSave () {
      if (this.$refs.configForm) {
        let flag = true
        this.$refs.configForm.validate(valid => {
          if (!valid) {
            this.$message.warning(this.$t('common.data_view_config_valid'))
            flag = false
          }
        })
        if (!flag) return flag
      } else if (!this.$refs.configForm && !this.viewForm.name) {
        this.$message.warning(this.$t('common.data_view_config_valid'))
        return false
      }
      if (this.arrParts && this.arrParts.length === 0) {
        this.$message.warning(this.$t('common.has_no_widget'))
        return false
      }
      if (this.viewInfo.isShow) {
        let toolRes = await API.common.getFirstToolLevelCount()
        let displayBoardRes = await API.common.getDisplayBoardShowCount()
        let count = toolRes.data + displayBoardRes.data
        if (count > 5) {
          this.$message.warning(this.$t('common.tool_nav_num_limit'))
          return false
        }
      }
      let params = {
        backgroundImageId: this.viewInfo.backgroundImageId === -1 ? null : this.viewInfo.backgroundImageId,
        id: this.dataViewId,
        isDisplayBoardName: this.viewInfo.isTitleShow ? 0 : 1,
        isShow: this.viewInfo.isShow ? 0 : 1,
        logoId: this.viewInfo.logoId === -1 ? null : this.viewInfo.logoId,
        name: this.viewInfo.name,
        title: this.viewInfo.title,
        widgetList: [],
        width: this.maxWidth,
        height: this.maxHeight
      }
      let parts = JSON.parse(JSON.stringify(this.arrParts))
      parts.forEach(item => {
        delete item.mode
        item.widgetWidth = item.width
        item.widgetHeight = item.height
        item.option = JSON.stringify(item.option)
        if (!item.resizable) {
          delete item.widgetWidth
          delete item.widgetHeight
        }
        params.widgetList.push(item)
      })
      API.dataView.updateDataView(params).then(res => {
        this.$message({
          message: this.$t('management.home.msg_apply_success'),
          type: 'success'
        })
        if (!this.getQueryString('key')) {
          setTimeout(() => {
            location.href = `${location.origin}${location.pathname}?branch=full&key=${res.data}`
          }, 2000)
        }
      })
    },
    // 记录当前滚动条变化
    handleScrollChange (scroll) {
      this.scrollTop = scroll.scrollTop
      this.scrollLeft = scroll.scrollLeft
    },
    resolveSettingJson (json, widget) {
      let _options = JSON.parse(JSON.stringify(json.options ? json.options : []))
      this.$set(widget, 'setting', _options)
      if (!widget.option && _options.length) {
        let _res = {}
        _options.forEach(item => {
          _res[item.key] = item.defaultValue
        })
        this.$set(widget, 'option', _res)
      }
    }
  },
  watch: {
    backgroundImgInfo: {
      handler () {
        this.viewForm.backgroundImageId = this.backgroundImgInfo.fileId
        this.viewForm.backgroundImageUrl = this.backgroundImgInfo.path
      },
      deep: true
    },
    viewLogoInfo: {
      handler () {
        this.viewForm.logoId = this.viewLogoInfo.fileId
        this.viewForm.logoUrl = this.viewLogoInfo.path
      },
      deep: true
    }
  },
  mixins: [getQueryString]
}

</script>

<style lang="scss" scoped>
@import "../../../../assets/styles/func.scss";
.page {
  width: 100%;
  height: 100%;
  ::v-deep .m-main-scroll-wrap {
    position: absolute !important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .m-main-container {
    position: relative;
    // width: vw(1920);
    // height: vw(1080);
  }
  .m-main-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .u-virtual-module {
    display: block;
    position: absolute;
    max-width: 200px;
    padding: 4px 8px;
    box-sizing: border-box;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0);
    margin: 4px;
    border-radius: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    z-index: 7;
  }
}
::v-deep .m-config-form {
  padding: 28px;
  .m-upload-container {
    width: 320px;
    height: 180px;
  }
}
</style>
